<template>
  <div class="info" v-loading="infoLoad">
    <el-button class="back el-icon-arrow-left" plain @click="goBack"
      >返回</el-button
    >
    <el-form
      class="form-box"
      ref="form"
      :rules="rules"
      :model="form"
      label-width="135px"
      size="small"
    >
      <h1>基本信息</h1>
      <el-form-item label="头像:">
        <upload-link
          accept=".png, .jpeg, .jpg"
          ref="userlogo"
          @changeUpload="changeLogoUpload"
          :fileList="[]"
          :multiple="false"
          :showFileList="false"
        >
          <template slot="body">
            <el-avatar
              :size="70"
              :src="form.userLogo ? form.userLogo : userLogo"
            ></el-avatar>
          </template>
        </upload-link>
      </el-form-item>
      <el-form-item label="真实姓名:" prop="userName">
        <el-input
          v-model="form.userName"
          placeholder="请输入"
          maxlength="20"
          show-word-limit
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别:" prop="userSex">
        <el-radio-group v-model="form.userSex">
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="出生年月:" prop="birthday">
        <el-date-picker
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          v-model="form.birthday"
          style="width: 400px"
        ></el-date-picker>
      </el-form-item>
      <h1>教师信息</h1>
      <el-form-item label="师训号:" prop="teacherArchivesDTO.teacherNum">
        <el-input
          style="width: 400px"
          maxlength="20"
          show-word-limit
          v-model="form.teacherArchivesDTO.teacherNum"
        ></el-input>
      </el-form-item>
      <el-form-item label="所在校区:" prop="schoolName">
        <school-selector
          dicType="module"
          :clearable="false"
          v-model="form.schoolName"
        ></school-selector>
      </el-form-item>

      <el-form-item label="手机号:" prop="mobile">
        <el-input
          v-model="form.mobile"
          maxlength="11"
          show-word-limit
          placeholder="请输入"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="年级/学科:" prop="gradeDiscipTable">
        <el-button type="text" @click="addPop">添加</el-button>
        <ul class="grade-ul">
          <li v-for="i in gradeDiscipTable" :key="i.id">
            <span>{{ i.schoolName }}</span>
            <span>{{ i.gradeName }}</span>
            <span>{{ i.className }}</span>
            <span>{{ i.disciplineName }}</span>
            <span>班主任：{{ i.isBzr ? "是" : "否" }}</span>
            <el-button
              type="text"
              class="el-icon-close delrad"
              @click="delGc(i.id)"
            ></el-button>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="普通话等级:" prop="remarkTem.speakLevel">
        <dicSelector
          dicType="mandarin"
          v-model="form.remarkTem.speakLevel"
        ></dicSelector>
        <p></p>
        <upload-multiple
          :typeList="['image']"
          :limit="5"
          :fileLimit="0.488"
          @uploadFile="uploadFilePth"
          :fileInfoList="form.remarkTem.speakLevelAttr"
        ></upload-multiple>
      </el-form-item>
      <el-form-item
        label="最高学历毕业时间"
        prop="teacherArchivesDTO.graduateDate"
      >
        <el-date-picker
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          v-model="form.teacherArchivesDTO.graduateDate"
          style="width: 400px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="参加工作时间" prop="remarkTem.joinWorkDate">
        <el-date-picker
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          v-model="form.remarkTem.joinWorkDate"
          style="width: 400px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="教师编制" prop="remarkTem.organization">
        <el-radio-group v-model="form.remarkTem.organization">
          <el-radio :label="1">在编</el-radio>
          <el-radio :label="0">外编</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="从事教育工作时间"
        prop="teacherArchivesDTO.startWorkDate"
      >
        <el-date-picker
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          v-model="form.teacherArchivesDTO.startWorkDate"
          style="width: 400px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="进本单位时间" prop="remarkTem.jbdwWorkDate">
        <el-date-picker
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          v-model="form.remarkTem.jbdwWorkDate"
          style="width: 400px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="学历:" prop="teacherArchivesDTO.educationObj">
        <dicSelector
          dicType="education_type"
          v-model="form.teacherArchivesDTO.educationObj"
        ></dicSelector>
      </el-form-item>
      <el-form-item label="学位:" prop="remarkTem.stuLevel">
        <dicSelector
          dicType="academic-degree"
          v-model="form.remarkTem.stuLevel"
        ></dicSelector>
      </el-form-item>
      <el-form-item label="职称:" prop="teacherArchivesDTO.academicTitlesObj">
        <dicSelector
          dicType="academic_titles"
          v-model="form.teacherArchivesDTO.academicTitlesObj"
        ></dicSelector>
        <p></p>
        <upload-multiple
          :typeList="['image']"
          :limit="5"
          :fileLimit="0.488"
          @uploadFile="uploadFileZc"
          :fileInfoList="form.remarkTem.zcAttr"
        ></upload-multiple>
      </el-form-item>
      <el-form-item label="起聘时间:" prop="remarkTem.employDate">
        <el-date-picker
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          v-model="form.remarkTem.employDate"
          style="width: 400px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="岗位等级:" prop="remarkTem.gwLevel">
        <dicSelector
          dicType="post-grade"
          v-model="form.remarkTem.gwLevel"
        ></dicSelector>
      </el-form-item>
      <el-form-item label="专业资历" prop="remarkTem.proTarget">
        <dicRadio
          controlType="radio"
          dicType="proTarget"
          v-model="form.remarkTem.proTarget"
        ></dicRadio>
      </el-form-item>
      <el-form-item label="教龄" prop="remarkTem.teachYear">
        <el-input
          type="number"
          show-word-limit
          v-model="form.remarkTem.teachYear"
          placeholder="请输入"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="任课节数" prop="remarkTem.teachNum">
        <el-input
          type="number"
          show-word-limit
          v-model="form.remarkTem.teachNum"
          placeholder="请输入"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="进修情况" prop="remarkTem.furtherEdu">
        <el-input
          maxlength="50"
          show-word-limit
          v-model="form.remarkTem.furtherEdu"
          placeholder="请输入"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="社会工作" prop="remarkTem.socialWork">
        <el-input
          maxlength="50"
          show-word-limit
          v-model="form.remarkTem.socialWork"
          placeholder="请输入"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="特长" prop="remarkTem.speciality">
        <el-input
          maxlength="50"
          show-word-limit
          v-model="form.remarkTem.speciality"
          placeholder="请输入"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="校内职务:" prop="teacherArchivesDTO.schoolDuty">
        <dicSelector
          dicType="teacherDuty"
          controlType="radio"
          v-model="form.teacherArchivesDTO.schoolDuty"
        ></dicSelector>
      </el-form-item>
      <!-- <el-form-item label="所属学院:" prop="remarkTem.affiliatedCollege">
        <dicSelector dicType="affiliated-college" v-model="form.remarkTem.affiliatedCollege"></dicSelector>
      </el-form-item> -->
      <el-form-item label="毕业学校:" prop="teacherArchivesDTO.graduateSchool">
        <el-input
          maxlength="50"
          show-word-limit
          v-model="form.teacherArchivesDTO.graduateSchool"
          placeholder="请输入"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item label="专业:" prop="teacherArchivesDTO.major">
        <el-input
          maxlength="50"
          show-word-limit
          v-model="form.teacherArchivesDTO.major"
          placeholder="请输入"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          class="sub-btn"
          :loading="infoLoad"
          type="primary"
          @click="onSubmit"
          >保 存</el-button
        >
      </el-form-item>
    </el-form>
    <el-dialog
      title="年级/学科"
      :visible.sync="isShowPop"
      v-if="isShowPop"
      width="500px"
      center
    >
      <div class="transfer-box">
        <el-form
          ref="formgrade"
          label-width="90px"
          size="small"
          :rules="gradeRules"
          :model="formGrade"
        >
          <el-form-item label="校区" prop="schoolCode">
            <school-selector
              dicType="module"
              :clearable="false"
              v-model="formGrade.schoolCode"
              @change="schoolChange"
            ></school-selector>
          </el-form-item>
          <el-form-item label="年级/班级:" prop="gradeClass">
            <el-cascader
              v-if="editCascaderVisible"
              size="small"
              v-model="formGrade.gradeClass"
              :props="gradeClassProps"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="学科:" prop="discipline">
            <el-select placeholder="请选择学科" v-model="formGrade.discipline">
              <el-option
                v-for="item in options"
                :label="item.disciplineName"
                :value="item.disciplineCode"
                :key="item.disciplineCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否班主任:" prop="isBzr">
            <el-radio-group v-model="formGrade.isBzr">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import axios from "@/http/http.js";

import disciplineSelector from "@/components/school/disciplineSelector.vue";
import gradeSelector from "@/components/school/gradeSelector.vue";
import dicSelector from "@/components/school/dicSelector.vue";
import dicRadio from "@/components/school/dicRadio.vue";
import schoolSelector from "@/components/school/schoolSelector.vue";
import UploadMultiple from "@/components/upload/UploadMultiple.vue";
import UploadLink from "@/components/upload/UploadLink.vue";
export default {
  components: {
    gradeSelector,
    dicSelector,
    dicRadio,
    UploadMultiple,
    UploadLink,
    disciplineSelector,
    schoolSelector,
  },
  computed: {
    ...mapState(["userInfo", "schoolList"]),
  },
  data() {
    var gcValidate = (rule, value, callback) => {
      if (this.gradeDiscipTable.length === 0) {
        return callback(new Error("年级/学科不能为空"));
      } else {
        callback();
      }
    };
    var proTargetValidate = (rule, value, callback) => {
      if (this.form.remarkTem.proTarget.length === 0) {
        return callback(new Error("专业级别不能为空"));
      } else {
        callback();
      }
    };
    let that = this;
    return {
      isShowPop: false,
      infoLoad: false,
      editCascaderVisible: false,
      userLogo: require("@/assets/image/other/man_teacher.png"),

      wbd: [
        {
          dicCode: "1",
          dicName: "备课组长",
        },
      ],
      form: {
        userId: "",
        id: "",
        operatorId: "",
        schoolCodes: null,
        userLogo: "", //图
        userName: "",
        userSex: "男",
        mobile: "",
        //idno: "", //师训号 错误  无用
        birthday: "", //生日

        // schoolCode: "",
        // schoolName: "",
        //remarkTem  传json
        remarkTem: {
          speakLevel: "", //普通话等级
          speakLevelAttr: [], //普通话附件
          joinWorkDate: "", //参加工作时间
          organization: 0, //教师编制
          jbdwWorkDate: "", //进本单位
          stuLevel: "", //学位
          zcAttr: [], //职称附件
          employDate: "", //起聘时间
          gwLevel: "", //岗位等级
          affiliatedCollege: "", //所属院校
          userDuty: "", //校内职务 单选 之前 的 {}
          userDuty1: [], //校内职务 多选 现在 的 [{}]
          proTarget: "", //专业级别
          teachYear: "", //教龄
          teachNum: "", //任课节数
          furtherEdu: "", //进修情况
          socialWork: "", //社会工作
          speciality: "", //特长
        },

        //teacherArchivesDTO
        teacherArchivesDTO: {
          graduateDate: "", //毕业时间
          startWorkDate: "", //从事教育
          educationObj: "", //学历
          education: "",
          academicTitlesObj: "", // obj 职称
          academicTitles: "", //Code
          graduateSchool: "", //毕业学校
          major: "", //专业
          remark: "", //传json
          teacherNum: "", //师训号 不是 idno
          schoolDuty: "", //校内职务 单选 新的   舍弃userDuty userDuty1
        },

        //年级班级，学科
        //teacherDutyDTO
        teacherDutyDTO: null,
      },
      rules: {
        gradeDiscipTable: [
          {
            required: true,
            validator: gcValidate,
          },
        ],
        userName: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: ["change", "blur"],
          },
        ],
        birthday: [
          {
            required: true,
            message: "出生年月不能为空",
            trigger: ["change", "blur"],
          },
        ],
        mobile: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "remarkTem.speakLevel": [
          {
            required: true,
            message: "普通话等级不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "teacherArchivesDTO.graduateDate": [
          {
            required: true,
            message: "毕业时间不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "teacherArchivesDTO.teacherNum": [
          {
            required: true,
            message: "师训号不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "teacherArchivesDTO.schoolDuty": [
          {
            required: true,
            message: "校内职务不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "remarkTem.joinWorkDate": [
          {
            required: true,
            message: "参加工作时间不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "teacherArchivesDTO.startWorkDate": [
          {
            required: true,
            message: "从事教育时间不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "remarkTem.jbdwWorkDate": [
          {
            required: true,
            message: "进本单位时间不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "teacherArchivesDTO.educationObj": [
          {
            required: true,
            message: "学历不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "remarkTem.stuLevel": [
          {
            required: true,
            message: "学位不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "teacherArchivesDTO.academicTitlesObj": [
          {
            required: true,
            message: "职称不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "remarkTem.employDate": [
          {
            required: true,
            message: "起聘时间不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "remarkTem.gwLevel": [
          {
            required: true,
            message: "岗位等级不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "remarkTem.userDuty1": [
          {
            required: true,
            message: "校内职务不能为空",
            trigger: ["change", "blur"],
          },
        ],
        // "remarkTem.proTarget": [
        //   {
        //     required: true,
        //     validator: proTargetValidate,
        //     // trigger: ["change", "blur"]
        //   },
        // ],
        "teacherArchivesDTO.graduateSchool": [
          {
            required: true,
            message: "毕业院校不能为空",
            trigger: ["change", "blur"],
          },
        ],
        "teacherArchivesDTO.major": [
          {
            required: true,
            message: "专业不能为空",
            trigger: ["change", "blur"],
          },
        ],
        // "remarkTem.affiliatedCollege": [
        //   {
        //     required: true,
        //     message: "所属学院不能为空",
        //     trigger: ["change", "blur"],
        //   },
        // ],
      },
      ///////年级学科
      gradeClassProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, value } = node;
          if (level === 0) {
            postData("/school/getGradeList", {
              schoolCode: that.formGrade.schoolCode.schoolCode,
            }).then((res) => {
              const nodes = [];
              res.forEach((item) => {
                nodes.push({
                  value: item,
                  label: item.gradeName,
                  leaf: false,
                });
              });
              resolve(nodes);
            });
          } else if (level === 1) {
            getData("/school/getClassInfoList", {
              grade: value.grade,
              pageNum: 1,
              pageSize: -1,
              schoolCode: that.formGrade.schoolCode.schoolCode,
            }).then((res) => {
              const nodes = [];
              res.forEach((item) => {
                nodes.push({
                  value: item,
                  label: item.className,
                  leaf: true,
                });
              });
              resolve(nodes);
            });
          }
        },
      },
      options: [],

      gradeDiscipTable: [],
      formGrade: {
        schoolCode: "",
        gradeClass: [],
        discipline: "",
        isBzr: 0,
      },
      gradeRules: {
        gradeClass: {
          required: true,
          message: "请选择年级/班级",
          trigger: ["change", "blur"],
        },
        discipline: {
          required: true,
          message: "请选择学科",
          trigger: ["change", "blur"],
        },
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getDisciplinelList(schoolCode) {
      postData("/discipline/getDisciplinelList", {
        schoolCode: schoolCode,
      }).then((res) => {
        this.options = res;
      });
    },
    async init() {
      this.infoLoad = true;
      await this.$store.dispatch("getUserInfo");

      this.form.schoolCodes = this.userInfo.teacherSchoolList.map(
        (i) => i.schoolCode
      );
      this.form.userLogo = this.userInfo.userLogo;
      this.form.userName = this.userInfo.userName;
      this.form.userSex = this.userInfo.userSex;
      this.form.birthday = this.userInfo.birthday;
      //this.form.idno = this.userInfo.idno;
      this.form.mobile = this.userInfo.mobile;
      if (this.userInfo.teacherArchivesDTO) {
        this.form.teacherArchivesDTO.graduateDate =
          this.userInfo.teacherArchivesDTO.graduateDate;
        this.form.teacherArchivesDTO.startWorkDate =
          this.userInfo.teacherArchivesDTO.startWorkDate;
        this.form.teacherArchivesDTO.graduateSchool =
          this.userInfo.teacherArchivesDTO.graduateSchool;
        this.form.teacherArchivesDTO.major =
          this.userInfo.teacherArchivesDTO.major;
        this.form.teacherArchivesDTO.teacherNum =
          this.userInfo.teacherArchivesDTO.teacherNum;
        this.form.teacherArchivesDTO.schoolDuty =
          this.userInfo.teacherArchivesDTO.schoolDuty;
        this.form.schoolCode = this.userInfo.schoolCode;
        this.form.schoolName = this.userInfo.schoolName;
        if (this.userInfo.teacherArchivesDTO.remark) {
          this.form.remarkTem = JSON.parse(
            this.userInfo.teacherArchivesDTO.remark
          );
          //处理校内职务  弃用userDuty
          if (this.form.remarkTem.userDuty1) {
            console.log(
              "存在 这个字段 非第一次更新,remarkTem.userDuty 已传入里面"
            );
          } else {
            //第一次更新
            this.form.remarkTem.userDuty1 = [];
            this.form.remarkTem.userDuty1.push(this.form.remarkTem.userDuty);
          }
          //专业级别新加字段
          if (!this.form.remarkTem.proTarget) {
            this.form.remarkTem.proTarget = "";
          }
        }
        if (this.userInfo.teacherArchivesDTO.education) {
          this.form.teacherArchivesDTO.educationObj = {
            dicCode: this.userInfo.teacherArchivesDTO.education,
          };
        }
        if (this.userInfo.teacherArchivesDTO.academicTitles) {
          this.form.teacherArchivesDTO.academicTitlesObj = {
            dicCode: this.userInfo.teacherArchivesDTO.academicTitles,
          };
        }
      }

      //处理年级班级
      //teacherDutyDTO 班主任
      this.gradeDiscipTable = [];
      if (
        this.userInfo.teacherDutyList &&
        this.userInfo.teacherDutyList.length > 0
      ) {
        this.userInfo.teacherDutyList.forEach((i) => {
          i.isBzr = 1;
          this.gradeDiscipTable.push(i);
        });
      }

      //非班主任
      let { teacherInfoList } = await postData("/user/getTeacherInfoById", {
        schoolCode: this.userInfo.schoolCode,
        userId: this.userInfo.userId,
      });
      teacherInfoList.forEach((i) => {
        i.isBzr = 0;
        this.gradeDiscipTable.push(i);
      });
      this.infoLoad = false;
    },
    uploadFilePth(fileList) {
      this.form.remarkTem.speakLevelAttr = fileList;
    },
    uploadFileZc(fileList) {
      this.form.remarkTem.zcAttr = fileList;
    },
    changeLogoUpload(fileList) {
      this.form.userLogo = fileList[0].attachUrl;
    },
    onSubmit() {
      console.log(this.form);

      this.$refs.form.validate((valid) => {
        if (valid) {
          try {
            this.infoLoad = true;
            this.form.userId = this.userInfo.userId;
            this.form.id = this.userInfo.id;
            this.form.operatorId = this.userInfo.userId;
            this.form.teacherArchivesDTO.remark = JSON.stringify(
              this.form.remarkTem
            );
            this.form.teacherArchivesDTO.education =
              this.form.teacherArchivesDTO.educationObj.dicCode;
            this.form.teacherArchivesDTO.academicTitles =
              this.form.teacherArchivesDTO.academicTitlesObj.dicCode;

            console.log(this.form);
            //处理 班级 学年  学科
            let gcb = this.gradeDiscipTable.find((i) => i.isBzr === 1); //取第一个。只能是一个班的班主任
            if (gcb) {
              //是班主任
              this.form.teacherDutyDTO = Object.assign(gcb, {
                userDuty: "classLeader",
                userDutyDesc: "班主任",
              });
            } else {
              delete this.form.teacherDutyDTO;
            }

            this.$axios
              .post("/user/updateTeacherInfo", this.form)
              .then((res) => {
                if (res.resultCode == 200) {
                  //非班主任信息保存
                  let cgl = this.gradeDiscipTable.filter((i) => i.isBzr === 0);
                  postJson("/user/updateTeacherTaskInfo", {
                    taskList: cgl,
                    id: this.userInfo.id,
                    schoolCode: this.userInfo.schoolCode,
                    userId: this.userInfo.userId,
                    operatorId: this.userInfo.userId,
                  }).then((res) => {
                    this.infoLoad = false;
                    this.init();
                    this.$message({
                      message: "更新成功",
                      type: "success",
                      duration: 2000,
                      offset: 150,
                    });
                  });
                } else {
                  this.$message.error({
                    message: res.msg || "保存失败请稍后重试！",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                  this.infoLoad = false;
                  this.init();
                }
              })
              .catch((err) => {
                console.log("update error", err);
              });

            if (this.form.schoolName.schoolCode) {
              postData("/user/changeSchoolInfo", {
                schoolCode: this.form.schoolName.schoolCode,
                userId: this.userInfo.userId,
              });
            }
          } catch (err) {
            console.log("err", err);
            this.$message.error("提交错误请稍后重试！");
          }
        }
      });
    },
    schoolChange(v) {
      this.formGrade = {
        schoolCode: v,
        gradeClass: [],
        discipline: "",
        isBzr: this.formGrade.isBzr,
      };
      this.getDisciplinelList(v.schoolCode);
      this.editCascaderVisible = false;
      // 这里搞个定时器重新载入一下组件就可以触发组件拉取数据
      setTimeout(() => {
        this.editCascaderVisible = true;
      }, 1);
    },
    addPop() {
      this.formGrade = {
        schoolCode: "",
        grade: "",
        gradeName: "",
        discipline: "",
        isBzr: 0,
        gradeClass: [],
      };
      this.editCascaderVisible = false;
      this.isShowPop = true;
    },
    cancel() {
      this.isShowPop = false;
    },
    async addOk() {
      await this.$refs.formgrade.validate();
      if (
        this.gradeDiscipTable.length > 0 &&
        this.formGrade.isBzr === 1 &&
        this.gradeDiscipTable.some((i) => i.isBzr === 1)
      ) {
        this.$message.error("您已是其他班级班主任，不可重复选择!");
        return;
      }
      let gcOption = {
        schoolCode: "",
        disciplineCode: "",
        disciplineName: "",
        grade: "",
        gradeName: "",
        // classCode: "",
        // className: "",
        isBzr: "",
        id: "",
      };
      // gcOption.id = new Date().getTime();
      gcOption.schoolCode = this.formGrade.schoolCode.schoolCode;
      gcOption.schoolName = this.formGrade.schoolCode.schoolName;

      gcOption.disciplineCode = this.formGrade.discipline;

      for (let dic of this.options) {
        if (dic.disciplineCode == this.formGrade.discipline) {
          gcOption.disciplineName = dic.disciplineName;
          break;
        }
      }
      gcOption.grade = this.formGrade.gradeClass[0].grade;
      gcOption.gradeName = this.formGrade.gradeClass[0].gradeName;
      gcOption.classCode = this.formGrade.gradeClass[1].classCode;
      gcOption.className = this.formGrade.gradeClass[1].className;
      gcOption.isBzr = this.formGrade.isBzr;
      this.gradeDiscipTable.push(gcOption);
      this.isShowPop = false;
    },
    delGc(id) {
      this.gradeDiscipTable = this.gradeDiscipTable.filter((i) => i.id != id);
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.info {
  // border: 1px solid #000;
  background-color: #fff;

  .back {
    margin-left: 100px;
    margin-top: 20px;
  }

  .form-box {
    // border: 1px solid #000;
    width: 800px;
    margin: 0 auto;

    h1 {
      font-size: 16px;
      height: 35px;
      line-height: 35px;
    }

    .school-name {
      margin-right: 10px;
      font-size: 14.5px;
    }

    .grade-ul {
      margin-top: -1px;
      padding: 0px;

      // border: 1px solid #000;
      li {
        min-width: 400px;
        border: 1px solid #eee;
        max-width: 500px;

        span {
          margin: 0px 7px;
          font-size: 13px;
          padding: 4px 6px;
          // border: 1px solid #eee;
        }

        .delrad {
          float: right;
          margin-right: 20px;
          color: @hong;
          font-size: 15px;
        }
      }
    }

    .sub-btn {
      margin-top: 30px;
      margin-left: 150px;
    }
  }

  /deep/.el-dialog--center {
    border-radius: 15px;
  }

  /deep/.el-dialog--center .el-dialog__body {
    padding: 0px 20px;
  }

  .transfer-box {
    padding: 30px 0px;
    border: 1px solid rgb(231, 227, 227);
    border-radius: 5px;

    .el-form {
      width: 360px;
      margin: 0 auto;
      // border: 1px solid #000;
    }

    // text-align: left;
  }
}
</style>
